export const getBuilderBlockMount = (templateId: string) => {
  const template = document.getElementById(templateId) as HTMLTemplateElement | null
  return (template?.content.firstElementChild as HTMLElement | null) ?? null
}
